import { REFERRALS_PATH } from './routePaths';

export const routes = {
  [REFERRALS_PATH]: {
    path: REFERRALS_PATH,
    displayName: 'Referral Dashboard',
    breadcrumbBackUrl: '/',
    discription: 'Manage Referrals',
    featureFlag: 'shouldShowReferralsTab'
  }
};

export default routes;
